// extracted by mini-css-extract-plugin
module.exports = {"noneSelected":"styles_noneSelected__3F4_o","handIcon":"styles_handIcon__-0lfg","description":"styles_description__M7MQW"};